module.exports = __webpack_public_path__ + "28b67065/img/delete-icon.eb7de062.svg";